<template>
  <ul v-if="room.users.length" v-show="showRoom" :style="app.isTeacher() ? 'padding: 0 0 0 15px' : 'padding: 0 0 0 4px'">
    <RoomUser v-for="user in room.sortedUsers" :key="user.name" :user="user" :room="room" @openUserMenu="onOpenUserMenu" />
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Room } from '../models/Room';
import RoomUser from './RoomUser.vue';
import { getApp } from '../models/App';

const app = getApp();

const props = defineProps<{
  name: string;
  showRoom: boolean;
  onOpenUserMenu: (userId: string, event: MouseEvent) => void;
}>();

const room = computed(() => Room.get(props.name) as Room);
</script>

<style scoped>
ul {
  margin: 0;
  /* padding: 0 0 0 15px; */
  list-style: none;
  display: flex;
  flex-direction: column;
}
</style>
